import { createBrowserHistory } from 'history';
 
const history = createBrowserHistory();
 
const customHistory = {
  ...history,
  push: (path: string, projectId: string | undefined) => {
    let prefixedPath = `/${projectId}${path}`;
    console.log('path: ', prefixedPath);
    prefixedPath = prefixedPath.replace(':projectId/', '');
    window.history.replaceState(null, '', prefixedPath);
    history.push(prefixedPath);
  },
};
 
export default customHistory;
